import { render, staticRenderFns } from "./AdminPagination.vue?vue&type=template&id=62a1486e&scoped=true"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"
import style0 from "./AdminPagination.vue?vue&type=style&index=0&id=62a1486e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1486e",
  null
  
)

export default component.exports